import React from "react";
import { API_BASE_URL_SERVER, API_END_POINTS_USER } from "@/utils/constant";
import axios from "axios";
import { decodeParams, encodeParams } from "@/utils/encodedecode";

export const contactUsApi = async (formData) => {
    try {
        let reqData = {data:encodeParams(formData)};
      const contactUSData = await axios.post(
        `${API_BASE_URL_SERVER}${API_END_POINTS_USER.CONTACTUS}`,
        reqData,
      );
      return decodeParams(contactUSData?.data);
    } catch (error) {
      console.error(error);
    }
  };

  export const demoRequestApi = async (formData) => {
    try {
        let reqData = {data:encodeParams(formData)};
      const response = await axios.post(
        `${API_BASE_URL_SERVER}${API_END_POINTS_USER.DEMO_REQUEST}`,
        reqData,
      );
      return decodeParams(response?.data);
    } catch (error) {
      console.error(error);
    }
  };

  export const getCommonApi = async (action, data) => {
    try {
      let params = {};
      if (data) {
        params.data = data;
      }
      // if (action.searchData) {
      //   params.search = action.searchData;
      // }
      // const headers = getHeaders();
      // let params = paramsData;
       let paramsData = { data: encodeParams(params) };
      let response = await axios.get(
        `${API_BASE_URL_SERVER}${action.apiEndPoint}`
      );
      return decodeParams(response?.data);
    } catch (error) {
      console.error(error);
      throw error;
    }
  };


  export const getBlogDataApi = async (paramsData) => {
    try {  
      // let params = paramsData;
      let params = { data: encodeParams(paramsData) };
      const blogData = await axios.get(
        `${API_BASE_URL_SERVER}${API_END_POINTS_USER.BLOGS}`,
        {
          params,
        }
      );

      // let serverResponse = decodeParams(campusData?.data);
      // console.log("campusData",serverResponse);
      // return {data:serverResponse};
      return decodeParams(blogData?.data)
    } catch (error) {
      console.error(error);
    }
  };

  export const getBlogDataByIdApi = async (id) => {
    try {

      console.log("id",id);
      

      let params = { action: "get" };
      let reqData = { data: encodeParams(params) };
      const response = await axios.get(
        `${API_BASE_URL_SERVER}${API_END_POINTS_USER.GET_BLOG_BY_ID}/${id}`,
        {
          params: reqData
        }
      );
      return decodeParams(response?.data);;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  export const getGuestLogDetailsApi = async (data) => {
    try {
      // const headers = getHeaders();
      let params = { data: encodeParams(data) };
      const response = await axios.get(
        `${API_BASE_URL_SERVER}${API_END_POINTS_USER.GUESTUSER_LOG_DETAILS}`, {
        headers: "demo",
        params: params
      }
      );
      return decodeParams(response?.data);
    } catch (error) {
      console.error(error);
      throw error;
    }
  }